export default [
  {
    path: '/admin/winning-reports',
    name: 'winning-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/winning-report')
  },
  {
    path: '/admin/claimed-reports',
    name: 'claimed-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/claimed')
  },
  {
    path: '/admin/unclaimed-reports',
    name: 'unclaimed-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/unclaimed')
  },
  {
    path: '/admin/dealer-balance-reports',
    name: 'dealer-balance-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/dealer-balance')
  },
  {
    path: '/admin/liability-reports',
    name: 'liability-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/liability')
  },
  {
    path: '/admin/ar-list-reports',
    name: 'ar-list-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/ar-list')
  },
  {
    path: '/admin/customer-profile-reports',
    name: 'customer-profile-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/customer-profile')
  },
  {
    path: '/admin/dealer-transaction-reports',
    name: 'dealer-transaction',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/dealer-transaction')
  },
  {
    path: '/admin/dealer-payout-reports',
    name: 'dealer-payout',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/dealer-payout')
  }
]
